module.exports = __webpack_public_path__ + "img/PS7.47fe736b.png";